const confirmation_email_pt = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "https://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
<html xmlns="https://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
  <meta name="viewport" content="width=device-width"/>
  <link rel="stylesheet" href="assets/css/foundation-emails.css">
  <title>Confirmação de Reserva</title>
  <style>
    @font-face {
      font-family: "SF Pro Text Regular";
      src: url(https://www.autorentacar.net/assets/fonts/sfprotextregular.ttf) format("truetype");
    }
    body {
      font-family: "SF Pro Text Regular", sans-serif;
      margin: 0;
      padding: 0;
      background-color: #f7f7f9;
      height: 100%;
    }
    html, body {
      height: 100%;
      overflow: hidden;
    }
    h2 {
        color: #262626;
        font-size: min(4vw, 22px);
    }
    p {
        font-size: min(3vw, 16px);
        line-height: 1.7em;
        color: #404040;
    }
    .footerp {
        font-size: min(2vw, 10px);
        color: #fff;
        padding: 18px;
        background-color: #324681;
        text-align: center;
    }
    .additional-info-box {
        font-size: min(3vw, 16px);
        background-color: #dbe0f0;
        padding: 8px;
        border-radius: 6px;
        margin: 50px auto;
        text-align: center;
        width: 90%;
    }
    @media screen and (max-width: 600px) {
      .container {
          width: 100%;
      }
      header {
          padding-top: 0.5em;
          padding-bottom: 0.5em;
      }
      footer {
          padding-top: 0.5em;
          padding-bottom: 0.5em;
      }
      h2 {
        font-size: min(4vw, 22px);
      }
      p {
        font-size: min(3vw, 16px);
      }
      .additional-info-box {
        font-size: min(3vw, 16px);
      }
    }
  </style>
</head>
<body>
  <table class="body" style="background-color: #f8f8f8; border-spacing: 0px;" data-made-with-foundation>
    <tr>
      <td valign="top">
        <center>
          <div style="background-color: #fff;">
            <img style="width: min(150px, 15%); padding-top: min(0.9em, 9px); padding-bottom: min(0.5em, 5px);" src="https://www.autorentacar.net/images/content/logo_emails.png" download></img>
          </div>
        </center>
        <div>
          <center><h2>Confirmação de Reserva ID-XXX</h2></center>
          <div style="padding-left: min(5vw, 50px); padding-right: min(5vw, 50px);">
            <p>
              Olá XXX,<br><br>
              Obrigado por nos escolher para o seu de aluguer de carro na Madeira! Temos o prazer de informar que as datas e o veículo solicitados estão disponíveis. A sua reserva com a Auto Rent-a-Car está confirmada, e os seus detalhes são os seguintes:
            </p>
            <!-- Reservation Details -->
            <p>
              <strong>Detalhes da Reserva:</strong><br>
              - Data de levantamento:</strong> XXX<br>
              - Local de levantamento:</strong> XXX<br>
              - Data de devolução:</strong> XXX<br>
              - Local de devolução:</strong> XXX
            </p>
            <!-- Car details -->
            <p>
              <strong>Detalhes do carro:</strong><br>
              - Número de carros:</strong> XXX<br>
              - Tipo de carro:</strong> Grupo XXX (Transmissão XXX - XXX)<br>
              - Número de condutores adicionais:</strong> XXX<br>
              - Cadeira para criança (0-3 anos):</strong> XXX<br>
              - Cadeira para bebé (4-7 anos):</strong> XXX<br>
              - Assento de elevação (8-12 anos):</strong> XXX<br>
              - Seguro:</strong> XXX<br>
            </p>
            </p>
            <!-- Pricing and Deposit -->
            <p>
              <strong>Preço total do aluguer (Numerário/Cartão débito ou crédito):</strong> XXX<br>
              <strong>Depósito (Numerário/Cartão crédito VISA):</strong> XXX
            </p>
            </p>
            <!-- Additional Information -->
            <br>
            <p style="text-align: justify">
              Relativamente ao pagamento, este só é efectuado no momento do levantamento. Aceitamos pagamentos em numerário (Euro), e com os principais cartões de crédito e débito (exceto American Express).
              Pedimos o depósito em numerário, pois é mais fácil de devolver no final do período de aluguer. Em último caso, é possível efetuar o depósito com um cartão de crédito VISA.
              <br></br>
              Agora solicitamos algumas informações adicionais, como o número do voo, o número de pessoas que chegarão e os detalhes da sua acomodação na Madeira. Desde já, agradecemos a sua cooperação!
              <br></br>
              Agora solicitamos os nome do seu cruzeiro para a sua chegada. Estaremos prontos para recebê-lo no terminal de cruzeiros, identificáveis pelo nosso logotipo e por um painel com o seu nome. Agradecemos desde já pela sua cooperação!
              <br></br>
              Dispomos de todas as informações necessárias. Confirme se tudo lhe parece correto. Se tiver mais alguma dúvida ou precisar de ajuda, não hesite em contactar-nos. Obrigado, e até breve!
            </p>
            <br>
            <!-- Closing Part -->
            <p>
              Atenciosamente,<br>
              XXX<br><br>
              Auto Rent-a-Car<br>
              +351 918888307 (Disponível no WhatsApp)<br>
              www.autorentacar.net
            </p>
          </div>
        </div>
        <center>
          <br>
          <p class="footerp">
            © 2023 Auto Rent-a-Car. Todos os direitos reservados.
          </p>
        </center>
      </td>
    </tr>
  </table>
</body>
</html>`

export default confirmation_email_pt;